import React from 'react';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

// Fila que muestra el archivo de programa ya cargado.
// - El nombre del archivo abre la visualización del programa en otra pestaña.
// - A la izquierda del botón de eliminar hay un botón para descargar.
//
// Props:
// - fileName: nombre del archivo.
// - fileMeta: texto secundario (ej. "Subido el 15/02/2024").
// - onView: abre la visualización del programa en otra pestaña.
// - onDownload: descarga el programa.
// - onDelete: elimina el programa.
// - busy: bloquea todas las acciones (mientras se sube/elimina) y atenúa la fila.
// - deleting: indica que la eliminación está en curso (texto del botón).
const UploadedFileRow = ({
  fileName,
  fileMeta,
  onView,
  onDownload,
  onDelete,
  busy = false,
  deleting = false,
}) => (
  <div
    className={`flex items-center justify-between gap-3 rounded-xl border border-primary/15 bg-background px-4 py-3 transition duration-150 ${
      busy ? 'opacity-70' : ''
    }`}>
    <div className='flex min-w-0 items-center gap-3'>
      <span className='flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary'>
        <DescriptionOutlinedIcon fontSize='small' />
      </span>
      <div className='min-w-0'>
        {/* El nombre del archivo gatilla la visualización en otra pestaña. */}
        <button
          type='button'
          onClick={() => onView?.()}
          disabled={busy}
          title='Ver programa en otra pestaña'
          className='block max-w-full truncate text-left font-semibold text-primary underline-offset-2 transition duration-150 hover:underline disabled:cursor-not-allowed disabled:text-muted-foreground disabled:no-underline'>
          {fileName}
        </button>
        {fileMeta && <p className='truncate text-xs text-muted-foreground'>{fileMeta}</p>}
      </div>
    </div>
    <div className='flex flex-shrink-0 items-center gap-2'>
      {/* Descargar (a la izquierda del botón de eliminar). */}
      <button
        type='button'
        onClick={() => onDownload?.()}
        disabled={busy}
        aria-label='Descargar programa'
        title='Descargar'
        className='inline-flex items-center justify-center rounded-lg border border-primary/20 p-2 text-primary transition duration-150 hover:bg-primary/10 disabled:cursor-not-allowed disabled:border-muted-foreground/20 disabled:text-muted-foreground disabled:hover:bg-transparent'>
        <FileDownloadOutlinedIcon fontSize='small' />
      </button>
      {/* Eliminar. */}
      <button
        type='button'
        onClick={() => onDelete()}
        disabled={busy}
        className='inline-flex items-center gap-1 rounded-lg bg-destructive px-3 py-2 text-sm font-semibold text-white transition duration-150 hover:bg-destructive/90 disabled:cursor-not-allowed disabled:opacity-50'>
        <DeleteOutlineIcon fontSize='small' />
        {deleting ? 'Eliminando…' : 'Eliminar'}
      </button>
    </div>
  </div>
);

export default UploadedFileRow;
